export default {
  title: 'Finde etwas, das dir gefällt!',
  description: 'Deine Bestellungen werden hier aufgelistet.',
  buttons: {
    order_now: 'Jetzt bestellen',
  },
};
